import { gql, type TypedDocumentNode } from "@apollo/client";
import type { CommissionPartnerNode, CommissionPartnerStatus } from "./types";

export interface CreateCommissionPartnerInput {
  name: string;
  legacyId: string;
  status: CommissionPartnerStatus;
}

export interface CreateCommissionPartnerResponse {
  commissionCreatePartner: {
    partner: CommissionPartnerNode;
  };
}

export const CREATE_COMMISSION_PARTNER_MUTATION: TypedDocumentNode<
  CreateCommissionPartnerResponse,
  { input: CreateCommissionPartnerInput }
> = gql`
  mutation CreateCommissionPartner($input: CreateCommissionPartnerInput!) {
    commissionCreatePartner(input: $input) {
      partner {
        id
        name
        legacyId
        status
      }
    }
  }
`;
